var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadContentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5872 7.77344H11.7819V2.09635C11.7819 1.47188 11.271 0.960938 10.6465 0.960938H6.10482C5.48034 0.960938 4.9694 1.47188 4.9694 2.09635V7.77344H3.16409C2.15357 7.77344 1.64263 8.99969 2.35794 9.715L7.5695 14.9266C8.01232 15.3694 8.72763 15.3694 9.17044 14.9266L14.382 9.715C15.0973 8.99969 14.5977 7.77344 13.5872 7.77344ZM0.427734 19.1276C0.427734 19.7521 0.938672 20.263 1.56315 20.263H15.1882C15.8126 20.263 16.3236 19.7521 16.3236 19.1276C16.3236 18.5031 15.8126 17.9922 15.1882 17.9922H1.56315C0.938672 17.9922 0.427734 18.5031 0.427734 19.1276Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadContentIcon);
export default __webpack_public_path__ + "static/media/DownloadContentIcon.c6f65c185d4f4b9c6a635760d9347ec2.svg";
export { ForwardRef as ReactComponent };